import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Observable } from 'rxjs/';
import { Language } from '../../tools/language/language';
import { LogService } from '../log/log.service';
import { Logtype } from 'src/app/enums/log/logtype.enum';

@Injectable({
  providedIn: 'root'
})
export class DialcodeService {
  private dialCodeSource: any = 'https://d3tmfelegj51yl.cloudfront.net/dialcode/dialcode.json';
  public dialcodeOBJ: any = {};
  public countriesOBJ: Observable<any>;
  private dialCodeArrSubject = new ReplaySubject(5);
  public dialCodeObservable$ = this.dialCodeArrSubject.asObservable();
  private lang: any = Language.currentLanguage.lenid;

  constructor(protected http: HttpClient, private _logService: LogService) {}

  getDialcode() {
    this.countriesOBJ = this.http.get(this.dialCodeSource);
  }

  setDialCode(countryISO: any): any {
    this.countriesOBJ.subscribe(
      (val) => {
        this.dialcodeOBJ = val.find((country) => country.alpha2Code === countryISO);
      },
      (err) => {
        this._logService.createLog(Logtype.ERROR, err, this.constructor.toString().match(/\w+/g)[1], 'createCart');
      },
      () => {
        this.setSubject(this.dialcodeOBJ);
      }
    );
  }

  setSubject(n: any) {
    this.dialCodeArrSubject.next(n);
  }
}
